(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root.document) return;
  root.ZenhaxFitment = api;
  function start() { api.initSearch(root.document); api.initResults(root.document); }
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function normalize(value) { return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase(); }
  function parseRange(value) {
    var match = String(value || '').trim().replace(/[\u2013\u2014]/g, '-').match(/^(\d{4})(?:\s*-\s*(\d{4})|(\+))?$/);
    if (!match) return null;
    var start = Number(match[1]);
    var end = match[3] ? Infinity : Number(match[2] || match[1]);
    return start >= 1900 && start <= 2200 && end >= start ? { start: start, end: end } : null;
  }
  function includesYear(range, year) {
    var parsed = parseRange(range);
    return !!parsed && Number.isInteger(Number(year)) && Number(year) >= parsed.start && Number(year) <= parsed.end;
  }
  function parseEntry(entry) {
    var parts = String(entry || '').split(/[\/\\]/).map(function (v) { return v.trim(); });
    if (parts.length !== 3 || !parts[0] || !parts[1] || !parseRange(parts[2])) return null;
    return { make: parts[0], model: parts[1], range: parts[2] };
  }
  function matchesVehicle(product, make, model, year) {
    return Array.isArray(product.fitment) && product.fitment.some(function (entry) {
      var fit = parseEntry(entry);
      return fit && normalize(fit.make) === normalize(make) && normalize(fit.model) === normalize(model) && includesYear(fit.range, year);
    });
  }
  function uniqueProducts(products) {
    var seen = new Set();
    return products.filter(function (product) {
      if (!product || !product.url || seen.has(product.url)) return false;
      seen.add(product.url);
      return true;
    });
  }
  function filterCatalog(products, make, model, year) {
    var matched = uniqueProducts(products).filter(function (p) { return matchesVehicle(p, make, model, year); });
    return { stereos: matched.filter(function (p) { return !p.isDashKit; }), kits: matched.filter(function (p) { return p.isDashKit; }) };
  }
  function buildIndex(products, currentYear) {
    var index = Object.create(null);
    products.forEach(function (product) {
      (Array.isArray(product.fitment) ? product.fitment : []).forEach(function (entry) {
        var fit = parseEntry(entry);
        if (!fit) return;
        var range = parseRange(fit.range);
        if (!index[fit.make]) index[fit.make] = Object.create(null);
        if (!index[fit.make][fit.model]) index[fit.make][fit.model] = new Set();
        var end = range.end === Infinity ? currentYear : Math.min(range.end, 2200);
        for (var year = range.start; year <= end; year++) index[fit.make][fit.model].add(year);
      });
    });
    Object.keys(index).forEach(function (make) {
      Object.keys(index[make]).forEach(function (model) {
        index[make][model] = Array.from(index[make][model]).sort(function (a, b) { return a - b; });
      });
    });
    return index;
  }
  function readJSON(doc, id) {
    var node = doc.getElementById(id);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }
  function initSearch(doc) {
    var form = doc.getElementById('fitment-filter');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    var make = doc.getElementById('fitment-make');
    var model = doc.getElementById('fitment-model');
    var year = doc.getElementById('fitment-year');
    var button = doc.getElementById('fitment-search');
    var index = buildIndex(readJSON(doc, 'fitment-data') || [], new Date().getFullYear());
    function reset(select) { select.replaceChildren(select.options[0]); select.selectedIndex = 0; }
    function option(select, label) { var node = doc.createElement('option'); node.value = label; node.textContent = label; select.appendChild(node); }
    Object.keys(index).sort().forEach(function (value) { option(make, value); });
    make.addEventListener('change', function () {
      reset(model); reset(year); year.disabled = true; button.disabled = true;
      model.disabled = !make.value;
      if (make.value) Object.keys(index[make.value]).sort().forEach(function (value) { option(model, value); });
    });
    model.addEventListener('change', function () {
      reset(year); button.disabled = true; year.disabled = !model.value;
      if (model.value) index[make.value][model.value].forEach(function (value) { option(year, value); });
    });
    year.addEventListener('change', function () { button.disabled = !year.value; });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!make.value || !model.value || !year.value) return;
      var url = new URL(form.action, doc.baseURI);
      url.searchParams.set('make', make.value); url.searchParams.set('model', model.value); url.searchParams.set('year', year.value);
      var preview = new URL(doc.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      doc.location.assign(url.href);
    });
  }
  function initResults(doc) {
    var page = doc.getElementById('ymm-results-page');
    if (!page || page.dataset.ready) return;
    page.dataset.ready = 'true';
    var labels = readJSON(doc, 'ymm-result-labels') || {};
    var params = new URL(doc.location.href).searchParams;
    var make = (params.get('make') || '').trim();
    var model = (params.get('model') || '').trim();
    var year = Number(params.get('year'));
    var title = doc.getElementById('ymm-title');
    var summary = doc.getElementById('ymm-summary');
    var empty = doc.getElementById('ymm-empty');
    if (!make || !model || !Number.isInteger(year) || year < 1900 || year > 2200) {
      title.textContent = labels.invalidSelection;
      doc.getElementById('ymm-empty-message').textContent = labels.invalidSelection;
      empty.hidden = false; return;
    }
    title.textContent = labels.titlePrefix + ' ' + make + ' ' + model + ' ' + year;
    var result = filterCatalog(readJSON(doc, 'ymm-product-data') || [], make, model, year);
    summary.textContent = labels.summary.replace('__COUNT__', result.stereos.length + result.kits.length);
    summary.hidden = false;
    function card(product, grid) {
      var article = doc.createElement('article'); article.className = 'ymm-card';
      var link = doc.createElement('a'); link.className = 'ymm-card__link'; link.href = product.url;
      var media = doc.createElement('div'); media.className = 'ymm-card__media';
      if (product.image) {
        var image = doc.createElement('img'); image.src = product.image; image.alt = product.title;
        image.loading = 'lazy'; image.decoding = 'async'; image.width = 600; image.height = 600; media.appendChild(image);
      }
      var body = doc.createElement('div'); body.className = 'ymm-card__body';
      var badge = doc.createElement('p'); badge.className = 'ymm-card__badge'; badge.textContent = product.isDashKit ? labels.kitBadge : labels.completeBadge;
      var heading = doc.createElement('h3'); heading.textContent = product.title;
      var footer = doc.createElement('div'); footer.className = 'ymm-card__footer';
      var price = doc.createElement('p'); price.className = 'ymm-card__price';
      price.textContent = product.isDashKit && Number(product.priceCents) === 0 ? labels.priceComingSoon : product.price;
      footer.appendChild(price);
      if (!product.available) { var availability = doc.createElement('span'); availability.className = 'ymm-card__availability'; availability.textContent = labels.unavailable; footer.appendChild(availability); }
      body.append(badge, heading, footer); link.append(media, body); article.appendChild(link); grid.appendChild(article);
    }
    [['stereo', result.stereos], ['kit', result.kits]].forEach(function (group) {
      if (!group[1].length) return;
      var grid = doc.getElementById('ymm-' + group[0] + '-grid');
      group[1].forEach(function (product) { card(product, grid); });
      doc.getElementById('ymm-' + group[0] + '-section').hidden = false;
    });
    empty.hidden = result.stereos.length + result.kits.length > 0;
  }
  return { includesYear: includesYear, parseEntry: parseEntry, matchesVehicle: matchesVehicle, filterCatalog: filterCatalog, buildIndex: buildIndex, initSearch: initSearch, initResults: initResults };
});
